<div
  #adminProfileDropdownTrigger="rtOverlayOrigin"
  [class.dropdown-open]="adminProfileDropdown.open"
  [class.has-company-logo]="logoThumbUrl()"
  (click)="adminProfileDropdown.openAt(adminProfileDropdownTrigger)"
  class="profile-avatar"
  rt-overlay-origin
>
  <div class="avatar-container" layout layout-align-items-center>
    <div class="avatar-inset-border"></div>
    @if (logoThumbUrl()) {
      <rt-company-logo [logoThumbUrl]="logoThumbUrl()" [class.active]="adminProfileDropdown.open">
        <ng-container
          *ngTemplateOutlet="avatarTemplate; context: { $implicit: 'top-nav-company-selector' }"
        ></ng-container>
        @if (verificationStatus()) {
          <ng-container *ngTemplateOutlet="verificationStatusIcon"></ng-container>
        }
      </rt-company-logo>
    } @else {
      <ng-container
        *ngTemplateOutlet="avatarTemplate; context: { $implicit: 'nav-item' }"
      ></ng-container>
      @if (verificationStatus()) {
        <ng-container *ngTemplateOutlet="verificationStatusIcon"></ng-container>
      }
    }
  </div>
</div>

<ng-template #verificationStatusIcon>
  <rt-icon
    class="verification-status-icon"
    [name]="verificationStatus()!.iconName"
    [colorToken]="verificationStatus()!.iconColor"
    size="small-x"
    [hasAutoHeight]="true"
  />
</ng-template>

<ng-template #avatarTemplate let-size>
  <rt-avatar
    [type]="avatarThumbUrl() ? 'image' : 'initials'"
    [size]="size"
    [imageSrc]="avatarThumbUrl()"
    [initials]="initials()"
    context="admin"
  >
  </rt-avatar>
</ng-template>

<ng-template
  #adminProfileDropdown="rtConnectedOverlay"
  (backdropClick)="adminProfileDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <tla-admin-profile-dropdown
    [currentMember]="currentMember()"
    [currentUser]="currentUser()!"
    [currentCompany]="currentCompany()"
    [companies]="companies()"
    [hasThemeSwitcher]="hasThemeSwitcher()"
    [themeName]="themeName()"
    [hasAmbassadorProgram]="hasAmbassadorProgram()"
    [hasImpactTrackerInsights]="hasImpactTrackerInsights()"
    (themeChange)="themeChange.emit($event)"
  />
</ng-template>
